import { privateAPI, UTILS } from '@Base/plugins/axios.js';

var service = 'documentos';

export default {

  // obtener documento incompleto
  getDocumentoIncompleto(idSolicitud, idTipoDocumento, cbok, cberr) {
    return privateAPI({
      url: `${service}/getUltimoDocumento/${idSolicitud}/${idTipoDocumento}`,
      method: 'GET',
			options: {
				responseType: 'blob',
			},
    })
		.then(function (response) {
			cbok(response.data);
      UTILS.downloadDocument(response);
		})
		.catch(function (error) {
      cberr(error);
		});
  },

}
